import React from 'react';
import { useThemeContext } from '@crema/context/ThemeContextProvider';
import { alpha, Box } from '@mui/material';
import { ReactComponent as Logo } from '@libs/assets/icon/logo.svg';
import { ReactComponent as LogoText } from '@libs/assets/icon/logo_text.svg';

type AppLogoProps = {
  color?: string;
  onClick?: () => void;
};

const AppLogo: React.FC<AppLogoProps> = ({ color, onClick = () => {} }) => {
  const { theme } = useThemeContext();
  const isChannelAdmin = process.env.NX_APPLICATION === 'ac';

  return (
    <Box
      sx={{
        height: { xs: 56, sm: 70 },
        padding: 2.5,
        display: 'flex',
        flexDirection: 'row',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
          height: { xs: 40, sm: 45 },
        },
      }}
      className="app-logo"
      onClick={onClick}
    >
      {isChannelAdmin ? (
        <Box
          component="img"
          src={`${process.env.NX_FRONT_S3_URL}/images/main/logo/podshop-logo.png`}
          alt={`logo`}
          sx={{ width: '160px' }}
        />
      ) : (
        <Logo />
      )}
      {/*<Logo fill={theme.palette.primary.main} />*/}
      {/*<Box*/}
      {/*  sx={{*/}
      {/*    mt: 1,*/}
      {/*    display: { xs: 'none', md: 'block' },*/}
      {/*    '& svg': {*/}
      {/*      height: { xs: 25, sm: 30 },*/}
      {/*    },*/}
      {/*  }}*/}
      {/*>*/}
      {/*  <LogoText fill={alpha(theme.palette.text.primary, 0.8)} />*/}
      {/*</Box>*/}
    </Box>
  );
};

export default AppLogo;
